import { alphaSort } from 'vet-bones/utils';
import { stringToSelectItem } from 'vet-bones/utils/select';

import { ReduxState } from 'src/store/types';

export const namedGraphItemsSelector =
  (databaseId: string) => (state: ReduxState) => {
    const namedGraphs = state.databases.databasesById[databaseId]?.namedGraphs;
    if (!namedGraphs) {
      return [];
    }
    return Object.values(namedGraphs)
      .filter((namedGraph) => !namedGraph.isVirtual)
      .map(({ iri }) => stringToSelectItem(iri))
      .sort(alphaSort(({ text }) => text));
  };
